import { render, staticRenderFns } from "./CaseFeedbackSettings.vue?vue&type=template&id=f2afbe3a&scoped=true"
import script from "./CaseFeedbackSettings.vue?vue&type=script&lang=js"
export * from "./CaseFeedbackSettings.vue?vue&type=script&lang=js"
import style0 from "./CaseFeedbackSettings.vue?vue&type=style&index=0&id=f2afbe3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2afbe3a",
  null
  
)

export default component.exports